import {
  Col,
  Row,
  Space,
  Table,
  Card,
  Spin,
  message,
  Divider,
  Button,
  Typography,
  Select,
  Input,
  InputNumber,
  Tag,
  Dropdown,
} from "antd";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  FilterOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
  SearchOutlined,
  DownOutlined,
  PrinterOutlined,
  ReloadOutlined,
  PlusOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import XLSX from "xlsx-js-style";
import {
  GET_GEO_ALL,
  HEADERS_EXPORT_BEN,
  POST_LOAD_LOST_CONTACT_JUDGE,
} from "../../API/apiUrls";
import CurrencyFormat from "../../../hook/CurrencyFormat";
import useLawyerNamesNew from "../../../hook/UseLawyerNameNew";
import "../../../assets/font/THSarabunNew-normal";
import "../../../assets/font/THSarabunNew-bold";
import MotionHoc from "../../../utils/MotionHoc";
import TokenCheck from "../../../hook/TokenCheck";
import AssignLawyerModal from "./modal/AssignLawyerModal";

const { Text } = Typography;
const { Option } = Select;

const OPTIONS_TYPE = [
  { value: "lsfhp", label: "จำนอง สัญญา 1" },
  { value: "vsfhp", label: "เช่าซื้อบัญชี 2" },
  { value: "sfhp", label: "เช่าซื้อบัญชี 8" },
  { value: "rpsl", label: "P-LOAN" },
];

const OPTIONS_TYPE_WITH_ALL = [
  { value: "all", label: "ทั้งหมด" },
  ...OPTIONS_TYPE,
];

const GRADE_COLOR = {
  A: "green",
  B: "blue",
  C: "orange",
  D: "volcano",
  X: "default",
};

// TODO: backend POST_LOAD_LOST_CONTACT_JUDGE ยังไม่ส่งจังหวัด/อำเภอ/ตำบลของทรัพย์มาด้วย
// ใช้ mock วนใส่ชั่วคราวเพื่อให้ตัวกรองพื้นที่ทำงานได้ก่อน แล้วค่อยเปลี่ยนเป็น field จริงจาก API ทีหลัง
const MOCK_LAND_GEO_POOL = [
  {
    province: "43",
    district: "01",
    subdistrict: "07",
    provDesc: "หนองคาย",
    distDesc: "อ.เมืองหนองคาย",
    subDistDesc: "หาดคำ",
  },
  {
    province: "41",
    district: "01",
    subdistrict: "01",
    provDesc: "อุดรธานี",
    distDesc: "อ.เมืองอุดรธานี",
    subDistDesc: "หมากแข้ง",
  },
  {
    province: "10",
    district: "01",
    subdistrict: "01",
    provDesc: "กรุงเทพมหานคร",
    distDesc: "เขตพระนคร",
    subDistDesc: "พระบรมมหาราชวัง",
  },
  {
    province: "50",
    district: "01",
    subdistrict: "01",
    provDesc: "เชียงใหม่",
    distDesc: "อ.เมืองเชียงใหม่",
    subDistDesc: "ศรีภูมิ",
  },
  {
    province: "90",
    district: "01",
    subdistrict: "01",
    provDesc: "สงขลา",
    distDesc: "อ.เมืองสงขลา",
    subDistDesc: "บ่อยาง",
  },
  {
    province: "12",
    district: "01",
    subdistrict: "01",
    provDesc: "นนทบุรี",
    distDesc: "อ.เมืองนนทบุรี",
    subDistDesc: "สวนใหญ่",
  },
];

const decorateWithMockGeo = (rows) =>
  rows.map((r, i) => ({
    ...r,
    ...MOCK_LAND_GEO_POOL[i % MOCK_LAND_GEO_POOL.length],
  }));

/* ----------------------- Select รวม style ------------------------ */
const geoSelectProps = {
  size: "large",
  showSearch: true,
  allowClear: true,
  optionFilterProp: "children",
  style: { minWidth: 200 },
};

const stepBadge = (n, color) => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: 22,
      height: 22,
      borderRadius: "50%",
      background: color,
      color: "#fff",
      fontSize: 12,
      fontWeight: 700,
    }}
  >
    {n}
  </span>
);

const getSchemaLabel = (dataType) =>
  OPTIONS_TYPE.find((o) => o.value === dataType)?.label || dataType || "-";

const getCaseTypeLabel = (flagLoanNew) =>
  flagLoanNew === 1 ? "ทำยอม" : flagLoanNew === 2 ? "พิพากษา" : "-";

const formatThaiDate = (d) =>
  d ? dayjs(d).add(543, "year").format("DD/MM/YYYY") : "-";

// วันที่รูปแบบ export ตามตัวอย่าง (2026-03-05)
const formatDateExport = (d) => (d ? dayjs(d).format("YYYY-MM-DD") : "-");

const Main = () => {
  const [, , currencyFormatPoint] = CurrencyFormat();
  const [signOut] = TokenCheck();
  const { nameLawyers, loadingUseLawyerNames } = useLawyerNamesNew({
    auto: true,
    toast: false,
  });

  const [loading, setLoading] = useState(false);
  const [arrayPay, setArrayPay] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const [schemaFilter, setSchemaFilter] = useState("all");
  const [caseTypeFilter, setCaseTypeFilter] = useState([1, 2]);
  const [searchContno, setSearchContno] = useState("");
  const [expMin, setExpMin] = useState(null);
  const [expMax, setExpMax] = useState(null);
  const [lawyerName, setLawyerName] = useState(undefined);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isModal, setIsModal] = useState(false);

  // geo raw — ใช้เฉพาะ map จังหวัด -> โซน (groupArea/groupDesc)
  const [geo, setGeo] = useState({ province: [] });

  // geo selections (เก็บเป็น "code" ระดับนั้น ๆ)
  const [selZone, setSelZone] = useState(null); // groupArea (number)
  const [selProvince, setSelProvince] = useState(null); // provCode (string)
  const [selDistrict, setSelDistrict] = useState(null); // distCode (string)
  const [selSubDistrict, setSelSubDistrict] = useState(null); // subDistCode (string)

  const getRowKey = useCallback(
    (r) => r.loanNewId ?? `${r.DATA_TYPE}_${r.CONTNO}`,
    [],
  );

  const lawyerOptions = useMemo(
    () =>
      Array.from(
        new Set(
          (nameLawyers ?? [])
            .filter(
              (l) =>
                (l.ROLE_ID === 3 || l.ROLE_ID === 4) &&
                l.ACTIVE_STATUS &&
                l.COMPANY_ID !== 3,
            )
            .map((l) => l.NNAME)
            .filter(Boolean),
        ),
      ).map((name) => ({ value: name, label: name })),
    [nameLawyers],
  );

  // ── Query ─────────────────────────────────────────────
  const queryData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.post(
        POST_LOAD_LOST_CONTACT_JUDGE,
        { userId: 1 },
        { headers: HEADERS_EXPORT_BEN },
      );
      const data = decorateWithMockGeo(Array.isArray(res.data) ? res.data : []);

      setArrayPay(data);
      setFilteredData(data);
    } catch (err) {
      message.error(
        err?.response?.status === 404 ? "ไม่พบข้อมูล" : "เกิดข้อผิดพลาด",
      );
      if (err?.response?.status === 401) {
        signOut();
      }
      setArrayPay([]);
      setFilteredData([]);
    } finally {
      setLoading(false);
    }
  }, [signOut]);

  useEffect(() => {
    queryData();
  }, []);

  /* --------------------------- Load GEO ---------------------------- */
  useEffect(() => {
    let isMounted = true;
    const loadGeoData = async () => {
      try {
        const res = await axios.get(GET_GEO_ALL, {
          headers: HEADERS_EXPORT_BEN,
        });
        const d = res.data || {};
        if (isMounted) {
          // เก็บเฉพาะ province เพื่อ lookup โซน (option พื้นที่ derive จาก data)
          setGeo({ province: d.province || [] });
        }
      } catch (error) {
        if (error.name !== "CanceledError" && isMounted) {
          message.error("ไม่สามารถโหลดข้อมูลพื้นที่ได้");
        }
      }
    };
    loadGeoData();
    return () => {
      isMounted = false;
    };
  }, []);

  /* ----------------------- helper: prov -> zone -------------------- */
  const provToZone = useCallback(
    (provCode) => {
      const p = geo.province.find(
        (x) => String(x.provCode) === String(provCode),
      );
      return p ? p.groupArea : null;
    },
    [geo.province],
  );

  const provToZoneDesc = useCallback(
    (provCode) => {
      const p = geo.province.find(
        (x) => String(x.provCode) === String(provCode),
      );
      return p ? p.groupDesc : null;
    },
    [geo.province],
  );

  /* ---------------- Cascading options (derive จาก arrayPay) --------- */
  // โซน: เฉพาะโซนที่มีทรัพย์จริง
  const zoneOptions = useMemo(() => {
    const map = new Map();
    arrayPay.forEach((r) => {
      const ga = provToZone(r.province);
      if (ga != null && !map.has(ga))
        map.set(ga, { value: ga, label: provToZoneDesc(r.province) });
    });
    return [...map.values()];
  }, [arrayPay, provToZone, provToZoneDesc]);

  // จังหวัด: เฉพาะที่มีทรัพย์ -> scope ด้วยโซน
  const provinceOptions = useMemo(() => {
    const map = new Map();
    arrayPay.forEach((r) => {
      if (selZone != null && provToZone(r.province) !== selZone) return;
      if (!map.has(r.province))
        map.set(r.province, { value: String(r.province), label: r.provDesc });
    });
    return [...map.values()];
  }, [arrayPay, selZone, provToZone]);

  // อำเภอ: เฉพาะที่มีทรัพย์ -> scope ด้วยจังหวัด, value composite กันชนข้ามจังหวัด
  const districtOptions = useMemo(() => {
    const map = new Map();
    arrayPay.forEach((r) => {
      if (selProvince != null && String(r.province) !== String(selProvince))
        return;
      const key = `${r.province}|${r.district}`;
      if (!map.has(key)) map.set(key, { value: key, label: r.distDesc });
    });
    return [...map.values()];
  }, [arrayPay, selProvince]);

  // ตำบล: ต้องเลือกจังหวัดก่อน -> scope ด้วยจังหวัด + อำเภอ
  const subDistrictOptions = useMemo(() => {
    if (selProvince == null) return [];
    const map = new Map();
    arrayPay.forEach((r) => {
      if (String(r.province) !== String(selProvince)) return;
      if (selDistrict != null && String(r.district) !== String(selDistrict))
        return;
      const key = `${r.province}|${r.district}|${r.subdistrict}`;
      if (!map.has(key)) map.set(key, { value: key, label: r.subDistDesc });
    });
    return [...map.values()];
  }, [arrayPay, selProvince, selDistrict]);

  /* --------------------------- Lock flags -------------------------- */
  const lockZone =
    selProvince != null || selDistrict != null || selSubDistrict != null;
  const lockProvince = selDistrict != null || selSubDistrict != null;
  const lockDistrict = selSubDistrict != null;

  const hasAreaFilter =
    selZone != null ||
    selProvince != null ||
    selDistrict != null ||
    selSubDistrict != null;

  /* ---------------------- Change handlers (auto-fill) -------------- */
  const handleZoneChange = useCallback((z) => {
    setSelZone(z ?? null);
    setSelProvince(null);
    setSelDistrict(null);
    setSelSubDistrict(null);
  }, []);

  const handleProvinceChange = useCallback(
    (provCode) => {
      if (provCode == null) {
        setSelProvince(null);
        setSelDistrict(null);
        setSelSubDistrict(null);
        return;
      }
      setSelProvince(provCode);
      setSelZone(provToZone(provCode));
      setSelDistrict(null);
      setSelSubDistrict(null);
    },
    [provToZone],
  );

  const handleDistrictChange = useCallback(
    (composite) => {
      if (!composite) {
        setSelDistrict(null);
        setSelSubDistrict(null);
        return;
      }
      const [provCode, distCode] = composite.split("|");
      setSelProvince(provCode);
      setSelZone(provToZone(provCode));
      setSelDistrict(distCode);
      setSelSubDistrict(null);
    },
    [provToZone],
  );

  const handleSubDistrictChange = useCallback(
    (composite) => {
      if (!composite) {
        setSelSubDistrict(null);
        return;
      }
      const [provCode, distCode, subCode] = composite.split("|");
      setSelProvince(provCode);
      setSelZone(provToZone(provCode));
      setSelDistrict(distCode);
      setSelSubDistrict(subCode);
    },
    [provToZone],
  );

  const handleResetArea = useCallback(() => {
    setSelZone(null);
    setSelProvince(null);
    setSelDistrict(null);
    setSelSubDistrict(null);
  }, []);

  /* ----------------- ค่า value ของ select (composite) -------------- */
  const districtValue =
    selProvince != null && selDistrict != null
      ? `${selProvince}|${selDistrict}`
      : undefined;
  const subDistrictValue =
    selProvince != null && selDistrict != null && selSubDistrict != null
      ? `${selProvince}|${selDistrict}|${selSubDistrict}`
      : undefined;

  /* --------------------------- กรองพื้นที่ -------------------------- */
  const matchesLocation = useCallback(
    (rec) => {
      if (!hasAreaFilter) return true;
      if (
        selSubDistrict != null &&
        String(rec.subdistrict) !== String(selSubDistrict)
      )
        return false;
      if (selDistrict != null && String(rec.district) !== String(selDistrict))
        return false;
      if (selProvince != null && String(rec.province) !== String(selProvince))
        return false;
      if (selZone != null && provToZone(rec.province) !== selZone) return false;
      return true;
    },
    [
      hasAreaFilter,
      selZone,
      selProvince,
      selDistrict,
      selSubDistrict,
      provToZone,
    ],
  );

  // ── Filter (มีผลเฉพาะตอนกดปุ่ม "กรองข้อมูล") ──────────
  const handleFilter = useCallback(() => {
    let filtered = arrayPay;

    if (schemaFilter !== "all") {
      filtered = filtered.filter((d) => d.DATA_TYPE === schemaFilter);
    }
    if (caseTypeFilter.length === 0) {
      filtered = [];
    } else if (caseTypeFilter.length === 1) {
      filtered = filtered.filter((d) => d.flagLoanNew === caseTypeFilter[0]);
    }
    if (lawyerName) {
      filtered = filtered.filter((d) => d.SALECOD === lawyerName);
    }
    if (expMin != null) {
      filtered = filtered.filter((d) => (d.EXPREAL ?? 0) >= expMin);
    }
    if (expMax != null) {
      filtered = filtered.filter((d) => (d.EXPREAL ?? 0) <= expMax);
    }
    if (hasAreaFilter) {
      filtered = filtered.filter(matchesLocation);
    }

    const query = searchContno.trim().toLowerCase();
    if (query) {
      filtered = filtered.filter(
        (d) =>
          d.CONTNO?.toLowerCase().includes(query) ||
          d.CODE_CONTNO?.toLowerCase().includes(query) ||
          d.ISSUNO?.toLowerCase().includes(query),
      );
    }

    setFilteredData(filtered);
    setSelectedRowKeys([]);
  }, [
    arrayPay,
    schemaFilter,
    caseTypeFilter,
    lawyerName,
    expMin,
    expMax,
    searchContno,
    hasAreaFilter,
    matchesLocation,
  ]);

  // ── กำหนดผู้รับผิดชอบ ─────────────────────────────────
  const handleAssignSuccess = useCallback(
    (assignedRows) => {
      const assignMap = new Map(
        assignedRows.map((row) => [row.key, row.lawyerName]),
      );
      const applyAssign = (list) =>
        list.map((r) =>
          assignMap.has(getRowKey(r))
            ? { ...r, SALECOD: assignMap.get(getRowKey(r)) }
            : r,
        );

      setArrayPay((prev) => applyAssign(prev));
      setFilteredData((prev) => applyAssign(prev));
      setSelectedRowKeys([]);
    },
    [getRowKey],
  );

  const hasActiveFilters =
    schemaFilter !== "all" ||
    !!lawyerName ||
    expMin != null ||
    expMax != null ||
    !!searchContno.trim() ||
    hasAreaFilter;

  const handleResetFilters = useCallback(() => {
    setSchemaFilter("all");
    setSearchContno("");
    setExpMin(null);
    setExpMax(null);
    setLawyerName(undefined);
    handleResetArea();
    setFilteredData(arrayPay);
    setSelectedRowKeys([]);
  }, [arrayPay, handleResetArea]);

  // ── Columns ───────────────────────────────────────────
  const columns = [
    {
      title: "ลำดับ",
      key: "index",
      align: "center",
      width: 60,
      render: (_, __, i) => i + 1,
    },
    {
      title: "รายละเอียด",
      key: "detail",
      align: "left",
      width: 260,
      render: (_, r) => (
        <div style={{ fontSize: 13, lineHeight: 1.7 }}>
          <div>
            <Text strong>เลขสัญญา {r.CONTNO || "-"}</Text>
          </div>
          <div>
            {`${r.SNAM || ""}${r.NAME1 || ""} ${r.NAME2 || ""}`.trim() || "-"}
          </div>
          <div style={{ color: "#888" }}>
            {getSchemaLabel(r.DATA_TYPE)} ・ เลขโฉนด/เลขตัวถัง {r.STRNO || "-"}
          </div>
          <div style={{ color: "#888" }}>ผู้รับผิดชอบ: {"-"}</div>
        </div>
      ),
    },
    {
      title: "สถานะ",
      key: "flagLoanNew",
      align: "center",
      width: 90,
      render: (_, r) => (
        <Tag color={r.flagLoanNew === 1 ? "gold" : "blue"}>
          {getCaseTypeLabel(r.flagLoanNew)}
        </Tag>
      ),
    },
    {
      title: "การชำระ",
      key: "payment",
      align: "left",
      width: 200,
      render: (_, r) => (
        <div style={{ fontSize: 13, lineHeight: 1.7 }}>
          <div>จ่ายขั้นต่ำ : {currencyFormatPoint(r.PAYLIMITAMT)} บาท</div>
          <div>วันที่จ่าย : {formatThaiDate(r.PAYDT)}</div>
          <div>ยอดที่จ่าย : {r.LPAYA ? currencyFormatPoint(r.LPAYA) : "-"}</div>
        </div>
      ),
    },
    {
      title: "ค้างงวด",
      key: "expreal",
      align: "center",
      width: 110,
      sorter: (a, b) => (a.EXPREAL ?? 0) - (b.EXPREAL ?? 0),
      render: (_, r) => (
        <div>
          {r.EXPREAL ?? "-"} งวด
          {r.EXP_FRM != null && r.EXP_TO != null && (
            <div style={{ color: "#888", fontSize: 12 }}>
              ({r.EXP_FRM}-{r.EXP_TO})
            </div>
          )}
        </div>
      ),
    },
    {
      title: "สถานะทรัพย์",
      dataIndex: "GRDCOD",
      key: "GRDCOD",
      align: "center",
      width: 70,
      render: (val) => (
        <Tag color={GRADE_COLOR[val] || "default"} style={{ fontWeight: 600 }}>
          {val || "-"}
        </Tag>
      ),
    },
    {
      title: "รายละเอียดทรัพย์",
      key: "fdate",
      align: "center",
      width: 110,
    },
  ];

  // ── Export helpers ────────────────────────────────────
  const selectedRows = useMemo(
    () => filteredData.filter((r) => selectedRowKeys.includes(getRowKey(r))),
    [filteredData, selectedRowKeys, getRowKey],
  );

  // ไม่ได้เลือกแถวใด ๆ → export ข้อมูลที่กรองไว้ทั้งหมดแทน
  const exportRows = selectedRows.length ? selectedRows : filteredData;

  const exportMenuItems = {
    items: [
      {
        key: "pdf",
        label: "Export PDF",
        icon: <FilePdfOutlined style={{ color: "#c0392b" }} />,
      },
      {
        key: "excel",
        label: "Export Excel",
        icon: <FileExcelOutlined style={{ color: "#27ae60" }} />,
      },
    ],
    onClick: ({ key }) => {
      if (key === "pdf") handlePrintPDF();
      if (key === "excel") handleExportExcel();
    },
  };

  // คอลัมน์ตามรูปตัวอย่าง (ตัด "วันทำสัญญา" ออก)
  const buildExportRows = () =>
    exportRows.map((r) => ({
      สัญญา: r.CONTNO || "",
      "ชื่อ-นามสกุล": `${r.SNAM || ""}${r.NAME1 || ""} ${r.NAME2 || ""}`.trim(),
      สถานะ: getCaseTypeLabel(r.flagLoanNew),
      วันงวดแรก: formatDateExport(r.FDATE),
      วันที่จ่ายล่าสุด: formatDateExport(r.LPAYD),
      วันที่จ่ายอื่นๆล่าสุด: formatDateExport(r.AROTHR_DATE),
      จำนวนวันขาดติดต่อ: r.LOSTDAY ?? "",
      ยอดกู้: parseFloat(r.TOTPRC) || 0,
      ค้างงวด: parseFloat(r.TOTUPAY) || 0,
      จำนวนงวด: r.TNOPAY ?? "",
      ชำระมาแล้ว: parseFloat(r.LPAYA) || 0,
      ยอดคงเหลือ: parseFloat(r.KARBAL) || 0,
      "ค้าง (งวด)": r.EXPREAL ?? "",
      ยอดค้างชำระ: parseFloat(r.TOTLKANG) || 0,
      ค้างงวดที่: r.EXP_FRM ?? "",
      ถึงงวดที่: r.EXP_TO ?? "",
      เกรด: r.GRDCOD || "",
      จ่ายขั้นต่ำ: parseFloat(r.PAYLIMITAMT) || 0,
      ทนายเจ้าของเคส: r.SALECOD || "",
    }));

  const handleExportExcel = () => {
    const rows = buildExportRows();
    if (!rows.length) {
      message.warning("ไม่มีข้อมูลสำหรับ Export");
      return;
    }

    const moneyKeys = [
      "ยอดกู้",
      "ค้างงวด",
      "ชำระมาแล้ว",
      "ยอดคงเหลือ",
      "ยอดค้างชำระ",
      "จ่ายขั้นต่ำ",
    ];

    const summaryRow = {
      สัญญา: "",
      "ชื่อ-นามสกุล": `รวมทั้งหมด ${rows.length} รายการ`,
    };
    moneyKeys.forEach((key) => {
      summaryRow[key] = rows.reduce(
        (sum, r) => sum + (parseFloat(r[key]) || 0),
        0,
      );
    });

    const allRows = [...rows, summaryRow];
    const ws = XLSX.utils.json_to_sheet(allRows);
    const keys = Object.keys(rows[0]);

    const evenFill = { patternType: "solid", fgColor: { rgb: "EBF5FF" } };
    const oddFill = { patternType: "solid", fgColor: { rgb: "FFFFFF" } };
    const summaryFill = { patternType: "solid", fgColor: { rgb: "D5E8D4" } };
    const borderStyle = {
      top: { style: "thin", color: { rgb: "CCCCCC" } },
      bottom: { style: "thin", color: { rgb: "CCCCCC" } },
      left: { style: "thin", color: { rgb: "CCCCCC" } },
      right: { style: "thin", color: { rgb: "CCCCCC" } },
    };

    // header
    keys.forEach((_, ci) => {
      const cellRef = XLSX.utils.encode_cell({ r: 0, c: ci });
      if (!ws[cellRef]) return;
      ws[cellRef].s = {
        fill: { patternType: "solid", fgColor: { rgb: "344962" } },
        font: { bold: true, color: { rgb: "FFFFFF" }, sz: 12 },
        alignment: { horizontal: "center", vertical: "center" },
        border: borderStyle,
      };
    });

    // data rows
    rows.forEach((row, ri) => {
      const fill = ri % 2 === 0 ? evenFill : oddFill;
      keys.forEach((key, ci) => {
        const cellRef = XLSX.utils.encode_cell({ r: ri + 1, c: ci });
        if (!ws[cellRef]) ws[cellRef] = { v: "", t: "s" };
        const isNumber = typeof row[key] === "number";
        const isMoney = moneyKeys.includes(key);
        ws[cellRef].s = {
          fill,
          font: { sz: 11 },
          alignment: {
            horizontal: isNumber ? "right" : "left",
            vertical: "center",
          },
          border: borderStyle,
          numFmt: isMoney ? "#,##0.00" : undefined,
        };
      });
    });

    // summary row
    const summaryRowIdx = rows.length + 1;
    keys.forEach((key, ci) => {
      const cellRef = XLSX.utils.encode_cell({ r: summaryRowIdx, c: ci });
      if (!ws[cellRef]) return;
      const isMoney = moneyKeys.includes(key);
      ws[cellRef].s = {
        fill: summaryFill,
        font: { bold: true, sz: 12 },
        alignment: {
          horizontal: isMoney ? "right" : "left",
          vertical: "center",
        },
        border: borderStyle,
        numFmt: isMoney ? "#,##0.00" : undefined,
      };
    });

    ws["!cols"] = keys.map((key) => ({ wch: Math.max(key.length * 2, 12) }));

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "รายงาน");
    XLSX.writeFile(
      wb,
      `รายงานหนี้ที่ขาดการติดต่อ_${dayjs().format("DDMMYYYY")}.xlsx`,
    );
    message.success("Export Excel สำเร็จ");
  };

  const handlePrintPDF = () => {
    if (!exportRows.length) {
      message.warning("ไม่มีข้อมูลสำหรับ Export");
      return;
    }

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });
    const pageWidth = doc.internal.pageSize.getWidth();
    const now = dayjs().format("DD/MM/YYYY HH:mm:ss");

    const drawHeader = (pageNum) => {
      doc.setFont("THSarabunNew", "bold");
      doc.setFontSize(16);
      doc.text("รายงานหนี้ที่ขาดการติดต่อ", pageWidth / 2, 8, {
        align: "center",
      });
      doc.setFont("THSarabunNew", "normal");
      doc.setFontSize(12);
      doc.text(`วันที่พิมพ์ ${now}`, 8, 16);
      doc.text(`หน้าที่ ${pageNum}`, pageWidth - 8, 16, { align: "right" });
    };

    const rows = buildExportRows();
    const tableBody = rows.map((r) =>
      Object.entries(r).map(([key, val]) =>
        // format ตัวเลขเงินให้มี comma ใน PDF
        [
          "ยอดกู้",
          "ค้างงวด",
          "ชำระมาแล้ว",
          "ยอดคงเหลือ",
          "ยอดค้างชำระ",
          "จ่ายขั้นต่ำ",
        ].includes(key)
          ? currencyFormatPoint(val)
          : val,
      ),
    );

    doc.autoTable({
      startY: 20,
      head: [Object.keys(rows[0])],
      body: tableBody,
      headStyles: {
        font: "THSarabunNew",
        fillColor: [52, 73, 94],
        textColor: 255,
        halign: "center",
        fontStyle: "bold",
        fontSize: 10,
      },
      styles: {
        font: "THSarabunNew",
        fontSize: 9, // 19 คอลัมน์ ลดขนาด font ไม่ให้ล้นหน้า
        cellPadding: 1,
        halign: "center",
      },
      columnStyles: {
        1: { halign: "left" }, // ชื่อ-นามสกุล
        7: { halign: "right" }, // ยอดกู้
        8: { halign: "right" }, // ค้างงวด
        10: { halign: "right" }, // ชำระมาแล้ว
        11: { halign: "right" }, // ยอดคงเหลือ
        13: { halign: "right" }, // ยอดค้างชำระ
        17: { halign: "right" }, // ขั้นต่ำ
        18: { halign: "left" }, // ทนายเจ้าของเคส
      },
      alternateRowStyles: { fillColor: [235, 245, 255] },
      didDrawPage: () =>
        drawHeader(doc.internal.getCurrentPageInfo().pageNumber),
      margin: { top: 20, left: 3, right: 3 },
    });

    doc.save(`รายงานหนี้ที่ขาดการติดต่อ_${dayjs().format("DDMMYYYY")}.pdf`);
  };

  return (
    <>
      <style>{`
      .row-even td { background-color: #f5f8ff !important; }
      .row-odd td  { background-color: #ffffff !important; }
    `}</style>
      <Spin spinning={loading} size="large" tip="Loading...">
        <Card style={{ marginBottom: 10 }}>
          <Divider style={{ fontSize: 20 }}>สัญญารอส่งบังคับคดี</Divider>

          {/* ── แถบกรองข้อมูล ── */}
          <Card
            size="small"
            title={
              <Space size={8} align="center">
                {stepBadge("1", "#090909")}
                <EnvironmentOutlined style={{ color: "#090909" }} />
                <Text strong style={{ color: "#090909" }}>
                  กรองข้อมูล
                </Text>
              </Space>
            }
            style={{ marginBottom: 12, background: "#fafafa" }}
          >
            <Row gutter={[16, 12]} align="bottom">
              <Col xs={24} sm={12} md={6} lg={5}>
                <Text type="secondary" style={{ fontSize: 13 }}>
                  บัญชี
                </Text>
                <Select
                  style={{ width: "100%" }}
                  options={OPTIONS_TYPE_WITH_ALL}
                  value={schemaFilter}
                  onChange={setSchemaFilter}
                  size="large"
                />
              </Col>

              <Col xs={24} sm={12} md={6} lg={5}>
                <Text type="secondary" style={{ fontSize: 13 }}>
                  ค้นหาเลขที่สัญญา
                </Text>
                <Input
                  placeholder="เช่น V2-0012430"
                  value={searchContno}
                  onChange={(e) => setSearchContno(e.target.value)}
                  onPressEnter={handleFilter}
                  prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
                  allowClear
                  size="small"
                />
              </Col>

              <Col xs={24} sm={12} md={6} lg={4}>
                <Text type="secondary" style={{ fontSize: 13 }}>
                  ค้างงวด (จาก - ถึง)
                </Text>
                <Space.Compact style={{ width: "100%" }}>
                  <InputNumber
                    min={0}
                    placeholder="จาก"
                    value={expMin}
                    onChange={setExpMin}
                    style={{ width: "50%" }}
                    size="large"
                  />
                  <InputNumber
                    min={0}
                    placeholder="ถึง"
                    value={expMax}
                    onChange={setExpMax}
                    style={{ width: "50%" }}
                    size="large"
                  />
                </Space.Compact>
              </Col>

              <Col xs={24} sm={12} md={6} lg={4}>
                <Text type="secondary" style={{ fontSize: 13 }}>
                  ผู้รับผิดชอบ
                </Text>
                <Select
                  style={{ width: "100%" }}
                  options={lawyerOptions}
                  value={lawyerName}
                  onChange={setLawyerName}
                  loading={loadingUseLawyerNames}
                  allowClear
                  showSearch
                  placeholder="ทั้งหมด"
                  size="large"
                />
              </Col>
              {/* 
              <Col xs={24} sm={12} md={6} lg={3}>
                <Text type="secondary" style={{ fontSize: 13 }}>
                  ประเภท
                </Text>
                <div>
                  <Checkbox.Group
                    options={OPTIONS_CASE_TYPE}
                    value={caseTypeFilter}
                    onChange={setCaseTypeFilter}
                  />
                </div>
              </Col> */}

              <Col flex="auto" style={{ textAlign: "right" }}>
                <Space>
                  <Button
                    color="orange"
                    variant="outlined"
                    icon={<FilterOutlined />}
                    onClick={handleFilter}
                  >
                    กรองข้อมูล
                  </Button>
                  <Button
                    icon={<ReloadOutlined />}
                    onClick={handleResetFilters}
                    color="red"
                    variant="outlined"
                  >
                    ล้างตัวกรอง
                  </Button>
                  <Dropdown
                    menu={exportMenuItems}
                    disabled={!filteredData.length}
                  >
                    <Button icon={<PrinterOutlined />}>
                      Export <DownOutlined />
                    </Button>
                  </Dropdown>
                </Space>
              </Col>
            </Row>
          </Card>

          {/* ── สรุปตัวกรองที่ใช้อยู่ ── */}
          {hasActiveFilters && (
            <Card
              size="small"
              style={{ background: "#f0f5ff", marginBottom: 12 }}
            >
              <Space split="|" size="large" wrap>
                <span>
                  <strong>ผลการค้นหา:</strong> {filteredData.length} รายการ
                </span>
                {schemaFilter !== "all" && (
                  <span>
                    <strong>บัญชี:</strong> {getSchemaLabel(schemaFilter)}
                  </span>
                )}
                {searchContno && (
                  <span>
                    <strong>ค้นหา:</strong> "{searchContno}"
                  </span>
                )}
                {(expMin != null || expMax != null) && (
                  <span>
                    <strong>ค้างงวด:</strong> {expMin ?? 0} - {expMax ?? "∞"}
                  </span>
                )}
                {lawyerName && (
                  <span>
                    <strong>ผู้รับผิดชอบ:</strong>
                    {lawyerName}
                  </span>
                )}
                {hasAreaFilter && (
                  <span>
                    <strong>พื้นที่:</strong>{" "}
                    {[
                      selZone != null &&
                        zoneOptions.find((o) => o.value === selZone)?.label,
                      selProvince != null &&
                        provinceOptions.find((o) => o.value === selProvince)
                          ?.label,
                      selDistrict != null &&
                        districtOptions.find((o) => o.value === districtValue)
                          ?.label,
                      selSubDistrict != null &&
                        subDistrictOptions.find(
                          (o) => o.value === subDistrictValue,
                        )?.label,
                    ]
                      .filter(Boolean)
                      .join(" > ")}
                  </span>
                )}
              </Space>
            </Card>
          )}
          <Card
            style={{
              marginBottom: 8,
              borderRadius: 12,
              border: "1px solid #91caff",
              background: "#f5faff",
            }}
          >
            <Row align="middle" style={{ marginBottom: 12 }} gutter={8}>
              <Col flex="auto">
                <Space size={8} align="center">
                  {stepBadge("2", "#1677ff")}
                  <EnvironmentOutlined style={{ color: "#1677ff" }} />
                  <Text strong style={{ color: "#1677ff" }}>
                    กรองตามพื้นที่
                  </Text>
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    (โซน → จังหวัด → อำเภอ → ตำบล)
                  </Text>
                </Space>
              </Col>
              <Col>
                <Button
                  icon={<ReloadOutlined />}
                  onClick={handleResetArea}
                  disabled={!hasAreaFilter}
                >
                  ล้างพื้นที่
                </Button>
              </Col>
            </Row>

            <Space size={10} wrap>
              <Select
                {...geoSelectProps}
                placeholder="เลือกโซน"
                value={selZone}
                disabled={lockZone}
                onChange={handleZoneChange}
                popupMatchSelectWidth={false}
                notFoundContent="ไม่มีข้อมูล"
              >
                {zoneOptions.map((o) => (
                  <Option key={o.value} value={o.value}>
                    {o.label}
                  </Option>
                ))}
              </Select>

              <Select
                {...geoSelectProps}
                placeholder="เลือกจังหวัด"
                value={selProvince}
                disabled={lockProvince}
                onChange={handleProvinceChange}
                notFoundContent="ไม่มีข้อมูล"
              >
                {provinceOptions.map((o) => (
                  <Option key={o.value} value={o.value}>
                    {o.label}
                  </Option>
                ))}
              </Select>

              <Select
                {...geoSelectProps}
                placeholder="เลือกอำเภอ"
                value={districtValue}
                disabled={lockDistrict}
                onChange={handleDistrictChange}
                notFoundContent="ไม่มีข้อมูล"
              >
                {districtOptions.map((o) => (
                  <Option key={o.value} value={o.value}>
                    {o.label}
                  </Option>
                ))}
              </Select>

              <Select
                {...geoSelectProps}
                placeholder={
                  selProvince == null ? "เลือกจังหวัดก่อน" : "เลือกตำบล"
                }
                value={subDistrictValue}
                disabled={selProvince == null}
                onChange={handleSubDistrictChange}
                notFoundContent="ไม่มีข้อมูล"
              >
                {subDistrictOptions.map((o) => (
                  <Option key={o.value} value={o.value}>
                    {o.label}
                  </Option>
                ))}
              </Select>
            </Space>
          </Card>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Space>
              <Button
                color="blue"
                variant="filled"
                icon={<PlusOutlined />}
                onClick={() => setIsModal(true)}
                disabled={selectedRows.length === 0}
                loading={loading}
                style={{ borderRadius: 8 }}
              >
                กำหนดผู้รับผิดชอบ{" "}
                {selectedRowKeys.length > 0 && ` (${selectedRowKeys.length})`}
              </Button>
              <Button
                color="orange"
                variant="filled"
                icon={<PlusOutlined />}
                onClick={() =>
                  message.success(
                    `ส่งสืบทรัพย์สำเร็จ (${selectedRowKeys.length}) สัญญา`,
                  )
                }
                disabled={selectedRows.length === 0}
                loading={loading}
                style={{ borderRadius: 8 }}
              >
                ส่งสืบทรัพย์ออนไลน์{" "}
                {selectedRowKeys.length > 0 && ` (${selectedRowKeys.length})`}
              </Button>
            </Space>
            <Text
              strong
              style={{
                margin: "10px 0",
              }}
            >
              จำนวนสัญญาทั้งหมด : {arrayPay.length} เคส
              {selectedRowKeys.length > 0
                ? ` (เลือก ${selectedRowKeys.length} รายการ)`
                : " (ไม่เลือกรายการ = Export ข้อมูลทั้งหมด)"}
            </Text>
          </div>
          <Table
            style={{ marginTop: 10 }}
            size="small"
            columns={columns}
            dataSource={filteredData}
            rowKey={getRowKey}
            rowSelection={{
              selectedRowKeys,
              onChange: setSelectedRowKeys,
            }}
            rowClassName={(_, index) =>
              index % 2 === 0 ? "row-even" : "row-odd"
            }
            scroll={{ x: 1100 }}
            pagination={{
              defaultPageSize: 50,
              showSizeChanger: true,
              showTotal: (t) => `ทั้งหมด ${t} รายการ`,
              pageSizeOptions: ["10", "20", "50", "100"],
            }}
          />
        </Card>
      </Spin>

      <AssignLawyerModal
        open={isModal}
        onClose={setIsModal}
        contracts={selectedRows}
        lawyerOptions={lawyerOptions}
        onSuccess={handleAssignSuccess}
      />
    </>
  );
};

const MainAssignInvestigatorOnsite = MotionHoc(Main);
export default MainAssignInvestigatorOnsite;
